import * as Yup from 'yup'
export type LoginValues = {
  identifier: string
  password: string
}

//export type LoginPhoneValues = {
//phone: string
//country_code: string
//password: string
//}
export const LoginSchema = Yup.object().shape({
  identifier: Yup.string().required('Required'),
  password: Yup.string()
    .min(6, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
})

//export const LoginPhoneSchema = Yup.object().shape({
//phone: Yup.number().required('Required'),
//country_code: Yup.string().required('Required'),
//password: Yup.string()
//.min(6, 'Too Short!')
//.max(50, 'Too Long!')
//.required('Required'),
//})
